// src/components/ContinueScreen.ts
import { loadSave, hasSave } from '../app/storage.js';

export function ContinueScreen(opts: { onContinue: () => void; onBack: () => void }): HTMLElement {
  const el = document.createElement('div');
  el.className = 'panel';

  if (!hasSave()) {
    el.innerHTML = `
      <div class="panel__head">
        <div class="kicker">Continuar</div>
        <div class="h1" style="font-size:clamp(1.6rem,5vw,2rem)"><span>Sin partida guardada</span></div>
        <p class="subtitle">Aún no has iniciado tu viaje. Crea una nueva partida para comenzar.</p>
      </div>
      <div class="panel__body">
        <div class="notice notice--warn">No se encontró ningún guardado en este navegador. En Fase 1 el guardado es local; en producción se sincronizará con D1.</div>
        <div class="btn-row" style="margin-top:1rem">
          <button class="btn btn--primary" data-action="back" type="button">← Volver al título</button>
        </div>
      </div>
    `;
    el.querySelector<HTMLButtonElement>('[data-action="back"]')!.addEventListener('click', opts.onBack);
    return el;
  }

  const save = loadSave()!;
  const updated = new Date(save.meta.updatedAt).toLocaleString('es-ES');
  const created = new Date(save.meta.createdAt).toLocaleString('es-ES');

  el.innerHTML = `
    <div class="panel__head">
      <div class="kicker">Continuar · Slot 1</div>
      <div class="h1" style="font-size:clamp(1.6rem,5vw,2rem)"><span>${esc(save.profile.name)}</span></div>
      <p class="subtitle">${esc(save.profile.title)} · ${esc(save.world.region)} · Cap. ${save.story.chapter}</p>
    </div>
    <div class="panel__body">
      <div style="display:grid;gap:.7rem">
        <div style="display:flex;gap:.6rem;flex-wrap:wrap">
          <span class="chip">📍 ${esc(save.world.region)} (${save.world.position.x}, ${save.world.position.y})</span>
          <span class="chip">🎒 ${save.inventory.length} objetos</span>
          <span class="chip">✦ ${save.team.asterias.length}/6 Asterias</span>
        </div>

        <div class="stat-grid">
          <div class="stat"><div class="stat__label">Creada</div><div class="stat__value" style="font-size:.82rem">${esc(created)}</div></div>
          <div class="stat"><div class="stat__label">Último guardado</div><div class="stat__value" style="font-size:.82rem">${esc(updated)}</div></div>
          <div class="stat"><div class="stat__label">Tiempo jugado</div><div class="stat__value">${fmtTime(save.stats.playtimeSeconds)}</div></div>
        </div>

        <div class="world-preview" aria-hidden="true">
          <div class="world-preview__map">
            <div class="world-preview__grid"></div>
            <div class="world-preview__pin" style="left:${34 + ((save.world.position.x||0) % 40)}%;top:${42 + ((save.world.position.y||0) % 24)}%"></div>
            <svg viewBox="0 0 400 132" style="position:absolute;inset:auto 0 0 0;height:54px" preserveAspectRatio="none">
              <path d="M0 52 L60 36 L110 48 L160 22 L210 40 L260 18 L310 38 L360 26 L400 36 L400 132 L0 132 Z" fill="#0a1430" stroke="rgba(255,255,255,.08)" stroke-width="1"/>
            </svg>
          </div>
          <div class="world-preview__body">
            <div><div class="world-preview__title">${esc((save.world as any).zoneId ?? save.world.region)} · (${Math.round(save.world.position.x)}, ${Math.round(save.world.position.y)})</div><div class="world-preview__sub">Fase 2 — entrar al mundo 3D 2.5D canvas</div></div>
            <span class="chip chip--ok">Listo</span>
          </div>
        </div>

        <div class="notice">
          Pulsa <strong>Continuar</strong> para aparecer en Aetheria y explorar Villa Aurelia y la Ruta Aurelia. Movimiento con WASD/Flechas, <strong>ESPACIO</strong> para hablar.
        </div>
      </div>

      <div class="btn-row" style="margin-top:1rem">
        <button class="btn btn--primary" data-action="continue" type="button">↻ Continuar aventura</button>
        <button class="btn btn--ghost" data-action="back" type="button">← Volver al título</button>
      </div>
    </div>
  `;

  el.querySelector<HTMLButtonElement>('[data-action="continue"]')!.addEventListener('click', opts.onContinue);
  el.querySelector<HTMLButtonElement>('[data-action="back"]')!.addEventListener('click', opts.onBack);
  return el;
}

function esc(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]!);
}
function fmtTime(sec: number): string {
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
}
